import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { loadRootSessionInputSchema } from "#/lib/serverInputSchemas";
import type { RequestGameContext } from "#/server/game/requestGameContext";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const loadRootSession = createServerFn({ method: "GET" })
  .validator(loadRootSessionInputSchema)
  .handler(async ({ data }): Promise<RequestGameContext> => {
    setRouteAction("root_session");
    return resolveRequestGameContext(data.playerId);
  });
